import React, { useEffect, useState } from "react";
import axios from "axios";
import "./VideoPlayer.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const API_KEY = process.env.REACT_APP_API_KEY_YT_DATA;


const PLAYLISTS = [
  {
    id: "PLth5BbxWzguNojWBU42nhJ01pRqU9ZpQT",
    name: "Prison Addon",
    icon: "fa-solid fa-gavel",
    description: "Prison addon tutorials, updates and guides."
  },
  {
    id: "PLB8Os_ipW4VE",
    name: "SkyBlock Addon",
    icon: "fa-solid fa-cloud",
    description: "SkyBlock addon tutorials, island setup and guides."
  }
];

export default function VideoPlayer() {
  const [selectedPlaylist, setSelectedPlaylist] = useState(PLAYLISTS[0]);
  const [videos, setVideos] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [play, setPlay] = useState(false);

  useEffect(() => {
    async function loadPlaylist() {
      setLoading(true);
      try {
        const res = await axios.get(
          "https://www.googleapis.com/youtube/v3/playlistItems",
          {
            params: {
              part: "snippet,contentDetails",
              playlistId: selectedPlaylist.id,
              maxResults: 50,
              key: API_KEY,
            },
          }
        );

        const items = res.data.items.map((item) => ({
          id: item.contentDetails.videoId,
          title: item.snippet.title,
          thumbnail: item.snippet.thumbnails.medium.url,
          channel: item.snippet.videoOwnerChannelTitle || "Vortex Network",
        }));

        setVideos(items);
        setCurrentVideo(items[0]);
        setPlay(false);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    loadPlaylist();
  }, [selectedPlaylist]);

  if (loading) return <div className="video-loading"><h2>Loading...</h2></div>;

  return (
    <div className="video-page">
      <div className="playlist-selector">
        {PLAYLISTS.map((p)=>(
          <button
            key={p.id}
            className={`playlist-button ${selectedPlaylist.id===p.id?"active":""}`}
            onClick={()=>setSelectedPlaylist(p)}
          >
            <i className={p.icon}></i>
            <div>
              <h3>{p.name}</h3>
              <span>{p.description}</span>
            </div>
          </button>
        ))}
      </div>

      <div className="video-container">
        <div className="video-main">
          <div className="video-badge">{selectedPlaylist.name}</div>
          <h1>{currentVideo?.title}</h1>
          <p>{selectedPlaylist.description}</p>

          <div className="video-wrapper" onClick={()=>setPlay(true)}>
            {!play ? (
              <div className="video-overlay">
                <img
                  className="video-thumbnail"
                  src={`https://img.youtube.com/vi/${currentVideo.id}/maxresdefault.jpg`}
                  alt={currentVideo.title}
                />
                <div className="play-button">
                  <i className="fa-solid fa-play"></i>
                </div>
              </div>
            ) : (
              <iframe
                title={currentVideo.title}
                allowFullScreen
                src={`https://www.youtube.com/embed/${currentVideo.id}?autoplay=1`}
              />
            )}
          </div>
        </div>

        <aside className="video-sidebar">
          <div className="sidebar-header">
            <h2>{selectedPlaylist.name}</h2>
            <span>{videos.length} Videos</span>
          </div>

          <div className="video-list">
            {videos.map((video,index)=>(
              <div
                key={video.id}
                className={`video-card ${currentVideo?.id===video.id?"active":""}`}
                onClick={()=>{
                  setCurrentVideo(video);
                  setPlay(false);
                }}
              >
                <div className="video-card-thumb">
                  <img src={video.thumbnail} alt={video.title}/>
                  <div className="video-number">{index+1}</div>
                </div>
                <div className="video-card-content">
                  <h4>{video.title}</h4>
                  <p>{video.channel}</p>
                </div>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./VideoPlayer.css";
// import "@fortawesome/fontawesome-free/css/all.min.css";

// const API_KEY = "AIzaSyAMEdMrph3MsxtS0lOl5xHF6AAh5OROyVE";
// const PLAYLIST_ID = "PLth5BbxWzguNojWBU42nhJ01pRqU9ZpQT";

// const API_KEY2 = "AIzaSyDheIauTMLfCrrn0ajYrB74jdkzvTN0hf8";

// const VideoPlayer = () => {
//   const [videos, setVideos] = useState([]);
//   const [currentVideo, setCurrentVideo] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [play, setPlay] = useState(false);

//   useEffect(() => {
//     async function fetchPlaylist() {
//       try {
//         const res = await axios.get(
//           "https://www.googleapis.com/youtube/v3/playlistItems",
//           {
//             params: {
//               part: "snippet,contentDetails",
//               maxResults: 25,
//               playlistId: PLAYLIST_ID,
//               key: API_KEY,
//             },
//           }
//         );

//         const items = res.data.items.map((item) => ({
//           id: item.contentDetails.videoId,
//           title: item.snippet.title,
//           thumbnail: item.snippet.thumbnails.medium.url,
//           channel: item.snippet.videoOwnerChannelTitle || "Vortex Network",
//         }));

//         setVideos(items);
//         setCurrentVideo(items[0]);
//       } catch (err) {
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchPlaylist();
//   }, []);

//   if (loading) {
//     return (
//       <div className="video-loading">
//         <div className="loader"></div>
//         <h2>Loading Videos...</h2>
//       </div>
//     );
//   }

//   return (
//     <div className="video-page">

//       {/* BACKGROUND */}
//       <div className="video-glow video-glow1"></div>
//       <div className="video-glow video-glow2"></div>

//       <div className="video-container">

//         {/* MAIN VIDEO */}
//         <div className="video-main">

//           <div className="video-top">

//             <div className="video-badge">
//               <i className="fa-brands fa-youtube"></i>
//               Vortex Videos
//             </div>

//             <h1>{currentVideo?.title}</h1>

//             <p>
//               Watch the latest Vortex Network tutorials, updates,
//               gameplay showcases, and addon guides.
//             </p>

//           </div>

//           <div
//             className="video-wrapper"
//             onClick={() => setPlay(true)}
//           >
//             {!play && (
//               <div className="video-overlay">

//                 <img
//                   src={`https://img.youtube.com/vi/${currentVideo.id}/maxresdefault.jpg`}
//                   alt={currentVideo.title}
//                   className="video-thumbnail"
//                 />

//                 <div className="video-dark"></div>

//                 <div className="play-button">
//                   <i className="fa-solid fa-play"></i>
//                 </div>

//               </div>
//             )}

//             {play && (
//               <iframe
//                 src={`https://www.youtube.com/embed/${currentVideo.id}?autoplay=1`}
//                 title={currentVideo.title}
//                 allowFullScreen
//               />
//             )}
//           </div>

//           <div className="video-info">

//             <div className="info-card">
//               <i className="fa-solid fa-film"></i>
//               <span>{videos.length} Videos</span>
//             </div>

//             <div className="info-card">
//               <i className="fa-solid fa-gamepad"></i>
//               <span>Minecraft Bedrock</span>
//             </div>

//             <div className="info-card">
//               <i className="fa-solid fa-bolt"></i>
//               <span>Latest Updates</span>
//             </div>

//           </div>

//         </div>

//         {/* SIDEBAR */}
//         <aside className="video-sidebar">

//           <div className="sidebar-header">
//             <h2>Playlist</h2>
//             <span>{videos.length} Videos</span>
//           </div>

//           <div className="video-list">

//             {videos.map((video, index) => (
//               <div
//                 key={video.id}
//                 className={`video-card ${
//                   currentVideo.id === video.id
//                     ? "active"
//                     : ""
//                 }`}
//                 onClick={() => {
//                   setCurrentVideo(video);
//                   setPlay(false);
//                 }}
//               >

//                 <div className="video-card-thumb">

//                   <img
//                     src={video.thumbnail}
//                     alt={video.title}
//                   />

//                   <div className="video-number">
//                     {index + 1}
//                   </div>

//                 </div>

//                 <div className="video-card-content">

//                   <h4>{video.title}</h4>

//                   <p>{video.channel}</p>

//                 </div>

//               </div>
//             ))}

//           </div>

//         </aside>

//       </div>
//     </div>
//   );
// };

// export default VideoPlayer;